import React from 'react';
import {
  Footprints, Megaphone, Trophy, HeartHandshake, Ear, Compass, Link as LinkIcon, Flame,
} from 'lucide-react';

export const BADGE_ICONS = {
  footprints: Footprints,
  megaphone: Megaphone,
  trophy: Trophy,
  'heart-handshake': HeartHandshake,
  ear: Ear,
  compass: Compass,
  link: LinkIcon,
  flame: Flame,
};

export const UserBadges = ({ badgeIds = [], defs = [], max = 3, size = 16 }) => {
  if (!badgeIds.length || !defs.length) return null;
  const shown = badgeIds.slice(0, max);
  return (
    <span className="inline-flex items-center gap-1 align-middle" data-testid="user-badges">
      {shown.map((id) => {
        const def = defs.find((d) => d.id === id);
        if (!def) return null;
        const Icon = BADGE_ICONS[def.icon] || Trophy;
        return (
          <span
            key={id}
            title={`${def.name} — ${def.description}`}
            className="inline-flex items-center justify-center rounded-full shrink-0"
            style={{ backgroundColor: `${def.color}1f`, width: size + 8, height: size + 8 }}
            data-testid={`badge-${id}`}
          >
            <Icon style={{ width: size - 4, height: size - 4, color: def.color }} />
          </span>
        );
      })}
      {badgeIds.length > max && (
        <span className="text-[10px] text-[#5C5C5C] font-semibold">+{badgeIds.length - max}</span>
      )}
    </span>
  );
};

export default UserBadges;
